import styled from "styled-components";

export const Panel = styled.section`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  border: 1px solid ${props => props.theme.colors.grey03};
  border-radius: 16px;
  background-color: ${props => props.theme.colors.white};
  box-shadow: ${props => props.theme.shadows.shadowXS};
  overflow: hidden;
`;

export const PanelHeader = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  border-bottom: 1px solid ${props => props.theme.colors.grey03};
`;

export const Tabs = styled.div`
  display: inline-flex;
  gap: 2px;
  padding: 3px;
  border-radius: 999px;
  background-color: ${props => props.theme.colors.grey01};
`;

export const Tab = styled.button<{ $active: boolean }>`
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 28px;
  padding: 0 12px;
  border: none;
  border-radius: 999px;
  background-color: ${props => (props.$active ? props.theme.colors.white : "transparent")};
  box-shadow: ${props => (props.$active ? props.theme.shadows.shadowXS : "none")};
  color: ${props => (props.$active ? props.theme.colors.text01 : props.theme.colors.text02)};
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  line-height: 16px;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    color: ${props => props.theme.colors.text01};
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px ${props => props.theme.colors.primaryLight};
  }

  i {
    font-size: 16px;
    line-height: 1;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const NewSticker = styled.span`
  display: inline-flex;
  align-items: center;
  height: 16px;
  padding: 0 6px;
  border-radius: 999px;
  background-color: ${props => props.theme.colors.primarySubtle};
  color: ${props => props.theme.colors.primary};
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
`;

export const TabBadge = styled.span`
  position: absolute;
  top: 3px;
  right: 5px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: ${props => props.theme.colors.danger};
  box-shadow: 0 0 0 2px ${props => props.theme.colors.white};
`;

export const PanelBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;
